import { i18n } from "@lingui/core";
import { detect, fromHtmlTag } from "@lingui/detect-locale";
import { I18nProvider } from "@lingui/react";
import { StrictMode, startTransition } from "react";
import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";
import { loadCatalog } from "./modules/lingui/lingui.ts";
import { setupLinguiValidation } from "./modules/lingui/validation.ts";

if (import.meta.env.MODE === "production" && import.meta.env.VITE_SENTRY_DSN) {
  import("./modules/sentry/monitoring.client.tsx").then(({ init }) => init());
}

async function main() {
  const locale = window.model?.language || detect(fromHtmlTag("lang")) || "en";

  await loadCatalog(locale);

  setupLinguiValidation();

  startTransition(() => {
    hydrateRoot(
      document,
      <StrictMode>
        <I18nProvider i18n={i18n}>
          <HydratedRouter />
        </I18nProvider>
      </StrictMode>,
    );
  });
}

main().catch((error) => console.error(error));
